import { render } from "./MyBrands.vue.js?vue&type=template&id=69c39ef0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrands.vue?vue&type=template&id=69c39ef0"
import script from "./MyBrands.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrands.vue?vue&type=script&lang=js"
export * from "./MyBrands.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/MyBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69c39ef0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69c39ef0', __exports__)) {
    api.reload('69c39ef0', __exports__)
  }
  
  module.hot.accept("./MyBrands.vue.js?vue&type=template&id=69c39ef0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrands.vue?vue&type=template&id=69c39ef0", () => {
    api.rerender('69c39ef0', render)
  })

}


export default __exports__